import API from './client'

export interface GlobalStats {
  period: string
  deliveries: {
    total: number
    delivered: number
    failed: number
    cancelled: number
    pending: number
    inTransit: number
    successRate: number
  }
  revenue: { total: number; commission: number; livreurs: number; currency: string }
  livreurs: {
    total: number
    online: number
    topPerformer: { name: string; deliveries: number; revenue: number } | null
  }
  expediteurs: {
    total: number
    topSender: { name: string; parcels: number; spent: number } | null
  }
}

export interface AdminTimelinePoint {
  _id: string
  total: number
  delivered: number
  failed: number
  cancelled: number
  revenue: number
}

export interface ExpediteurStats {
  period: string
  parcels: {
    total: number
    delivered: number
    failed: number
    cancelled: number
    pending: number
    inTransit: number
    successRate: number
  }
  spending: {
    total: number
    average: number
    currency: string
  }
  topLivreur: { id: string; name: string; deliveries: number } | null
  timeline: Array<{
    _id: string
    total: number
    delivered: number
    revenue: number
  }>
}

export const analyticsAPI = {
  getGlobalStats: async (period = 'month'): Promise<GlobalStats> => {
    const r = await API.get('/analytics/global', { params: { period } })
    return r.data
  },

  getTimeline: async (period = 'week'): Promise<{ period: string; timeline: AdminTimelinePoint[] }> => {
    const r = await API.get('/analytics/timeline', { params: { period } })
    return r.data
  },

  getExpediteurStats: async (
    period: 'week' | 'month' | 'year' = 'month',
    expediteurId?: string
  ): Promise<ExpediteurStats> => {
    const res = await API.get('/analytics/expediteur', { params: { period, expediteurId } })
    return res.data
  },

  getLivreurStats: (period = 'week', livreurId?: string) =>
    API.get('/analytics/livreur', { params: { period, livreurId } }),
}
